//modified from the following example:
//https://github.com/ghiscoding/angular-validation/wiki/Bootstrap-Decorator-(has-error)
export class validationDecorator implements ng.IDirective {
    public restrict = 'A';
    public require = '^form';
    public scope = {
        validationDecorator: '@'
    };

    public link = (scope: any, elements: ng.IAugmentedJQuery, attrs: ng.IAttributes, formCtrl: ng.IFormController) => {
        scope.form = formCtrl;

        scope.$watch(
            () => {
                //moving this in here to get around select isReady issue.
                if (!scope.fieldName) scope.fieldName = angular.element( elements[0].querySelector('input[name],select[name]') ).attr('name');
                return scope.form.$submitted && scope.form[scope.fieldName].$invalid;
            },
            (newVal, oldVal) => {
                if (newVal !== oldVal){
                    elements.toggleClass(scope.validationDecorator, newVal);
                }
            }
        );
    }

    public static factory(): ng.IDirectiveFactory {
        const directive: ng.IDirectiveFactory = () => new validationDecorator();
        return directive;
    }
}